// extracted by mini-css-extract-plugin
module.exports = {"featuresActionContainer":"style_featuresActionContainer__2A9a6"};